import { render, staticRenderFns } from "./proposed-fees.vue?vue&type=template&id=4614d704"
import script from "./proposed-fees.vue?vue&type=script&lang=js"
export * from "./proposed-fees.vue?vue&type=script&lang=js"
import style0 from "./proposed-fees.vue?vue&type=style&index=0&id=4614d704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports